<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 8V12L15 15" stroke="currentColor" stroke-width="1" stroke-linecap="round"
		></path> <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1"></circle>
	</svg>
</div>
